import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { RefreshCw } from 'lucide-react';

// Master "Reset Website Cache" button (clears every WP + OL cache layer).
// Shared between the WP Mgmt toolbar (non-TS roles) and the Tech Specialist's
// Dashboard welcome bar. See MASTER_CACHE_RESET.md.
export function ResetCacheButton({ orgId }) {
  const [busy, setBusy] = useState(false);
  const run = async () => {
    setBusy(true);
    try {
      const { data } = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/wp-cache/${orgId}/reset-all`, {}, { withCredentials: true });
      const L = data?.layers || {};
      const ok = (x) => (x && x.ok ? '✓' : '✗');
      const parts = `Transients ${ok(L.wp_transients)} · Deep ${ok(L.wp_deep)} · OL ${ok(L.ol_read_cache)} · Feed ${ok(L.ol_feed_version)}`;
      data?.ok
        ? toast.success(`Website cache fully reset — ${parts}. Reload the site to see the latest changes.`)
        : toast.warning(`Cache reset ran with issues — ${parts}.`);
    } catch (e) {
      toast.error(e.response?.data?.detail || `Cache reset failed: ${e.message}`);
    } finally { setBusy(false); }
  };
  return (
    <button
      onClick={run}
      disabled={busy}
      title="Master reset — clears every cache layer (transients, WP-Optimize, full-page cache, PHP opcache) so the site shows your latest changes right away"
      className="flex items-center gap-1.5 px-3 py-1.5 rounded-md text-xs font-medium whitespace-nowrap bg-teal-700/70 text-teal-100 hover:bg-teal-600 border border-teal-600/50 transition-colors disabled:opacity-60"
      data-testid="wpmgmt-reset-cache-btn"
    >
      <RefreshCw className={`h-3.5 w-3.5 ${busy ? 'animate-spin' : ''}`} /> Reset Cache
    </button>
  );
}

export default ResetCacheButton;
